<template>
	<b-modal :id="id" :visible="visible" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
		<b-container class="text-center">
			<b-row class="my-4">
				<b-col class="text-justify" v-html="message" />
			</b-row>
			<b-row class="my-4">
				<b-col>
					<elumin-loader />
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	export default
	{
		name: 'ProcessingModal',
		props:
		{
			id: { type: String, default: undefined },
			visible: Boolean,
			message: { type: String, default: undefined }
		},
		data () { return {}; }
	}
</script>
